/**
 * @generated SignedSource<<9c37352ec94d4416ebce38af1a427582>>
 * @relayHash b8b4bbd778fb7d984ab4ca02f7763855
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8723f2ef52372bc01dc6fcfbf348857a2c8f1b4b325fc60e73047ffc13ba1e42

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8723f2ef52372bc01dc6fcfbf348857a2c8f1b4b325fc60e73047ffc13ba1e42",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
